export default __webpack_public_path__ + "static/media/music.1c00dfc2.svg";